/**
 * Shared pagination utilities for order queue tabs.
 *
 * Extracted from OrderQueueTab/AllOrdersTab to avoid duplication.
 */

/**
 * Generate page numbers with ellipsis for pagination display.
 * Shows at most 7 page indicators (numbers + ellipsis).
 *
 * Pages are 0-indexed internally but displayed as 1-indexed.
 */
export function generatePageNumbers(current: number, total: number): (number | 'ellipsis')[] {
  if (total <= 0) return [];
  const safeCurrent = Math.max(0, Math.min(current, total - 1));
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);

  const pages: (number | 'ellipsis')[] = [0];

  if (safeCurrent > 2) pages.push('ellipsis');

  for (let i = Math.max(1, safeCurrent - 1); i <= Math.min(total - 2, safeCurrent + 1); i++) {
    pages.push(i);
  }

  if (safeCurrent < total - 3) pages.push('ellipsis');
  pages.push(total - 1);

  return pages;
}
